import React from "react";
import { Form, AutoComplete } from "antd";
import { Search } from "react-feather";
import "./AdnAutoComplete.css";

const AdnAutoComplete = ({
  placeholder,
  handleSearch,
  handleSelect,
  resultList,
  value,
  valueId,
  defaultValue,
  handleBlur,
  allowClear,
  handleClear,
  disabled,
  rules,
  className,
  name,
  label,
}) => {
  const { Option } = AutoComplete;
  return (
    <Form.Item name={name} label={label} className={className} rules={rules}>
      <div className="adn-autocomplete-wrapper">
        <AutoComplete
          className={`adn-autocomplete ${disabled ? "disabled" : ""}`}
          style={{
            width: "100%",
          }}
          placeholder={placeholder}
          onSearch={handleSearch}
          onSelect={(item, option) => handleSelect(item, option)}
          onClear={handleClear}
          defaultValue={defaultValue}
          onBlur={handleBlur}
          value={value}
          allowClear={allowClear || false}
          disabled={disabled}
        >
          {resultList.map((element) => (
            <Option key={element["id"]} value={element[valueId]}>
              {element[valueId]}
            </Option>
          ))}
        </AutoComplete>
        <Search className="adn-autocomplete-search-icon" size={16} />
      </div>
    </Form.Item>
  );
};

export default AdnAutoComplete;
